import {useMemo, useState} from 'react'

import type {ShowSuggestionsEvent, TriggerAndSuggestions} from '../types'

type SuggestionsCalculator = TriggerAndSuggestions['suggestionsCalculator']

type NormalizedTriggers = {
  triggers: Array<TriggerAndSuggestions['trigger']>
  calculatorByChar: Map<string, SuggestionsCalculator>
}

// The triggerAndSuggestions array must be memoized by the caller
export const useAutocompleteTriggersAndSuggestions = (triggerAndSuggestions: TriggerAndSuggestions[]) => {
  const [suggestionEvent, setSuggestionEvent] = useState<ShowSuggestionsEvent | null>(null)

  const normalized = useMemo<NormalizedTriggers>(() => {
    const triggers: Array<TriggerAndSuggestions['trigger']> = []
    const calculatorByChar = new Map<string, SuggestionsCalculator>()

    for (const {trigger, suggestionsCalculator} of triggerAndSuggestions) {
      triggers.push(trigger)
      calculatorByChar.set(trigger.triggerChar, suggestionsCalculator)
    }

    return {triggers, calculatorByChar}
  }, [triggerAndSuggestions])

  const suggestions = useMemo(() => {
    return suggestionEvent == null
      ? null
      : (normalized.calculatorByChar.get(suggestionEvent.trigger.triggerChar)?.(suggestionEvent.query) ?? null)
  }, [suggestionEvent, normalized.calculatorByChar])

  return {
    triggers: normalized.triggers,
    suggestions,
    setSuggestionEvent,
    active: suggestionEvent !== null,
  }
}
